import { ISubscription } from "@/types/subscription.type";
import { PaymentInfo } from "../../types/payment.type";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";


const API_URL = `${import.meta.env.VITE_API_URL}/subscriptions`;

const makeRequestDebounced = createDebounce(makeRequest, 200);

export function syncSubscriptionAsaas(renterId: string) {
  const url = `${API_URL}/sync/${renterId}`;
  const options = {
    method: "GET",
    skipUFParam: true,
    skipUFHeader: true,
    headers: { "Content-Type": "application/json" },
  };

  return makeRequestDebounced(url, options) as Promise<
    ApiResponseType<PaymentInfo>
  >;
}

export function getRenterSubscription(renterId: string) {
  const url = `${API_URL}/${renterId}`;
  const options = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };

  return makeRequestDebounced(url, options) as Promise<
    ApiResponseType<ISubscription[]>
  >;
}

const removeReadonlyFields = (data) => {
  delete data._id;
  delete data.createdAt;
  delete data.updatedAt;
}
export async function createSubscription(data: ISubscription) {
  removeReadonlyFields(data);
  const url = `${API_URL}/`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  const result = (await makeRequestDebounced(url, options)) as Promise<
    ApiResponseType<ISubscription>
  >;


  return result;
}

export async function updateSubscription(subscriptionId: string, data: ISubscription) {
  const url = `${API_URL}/${subscriptionId}`;
  const options = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  const result = (await makeRequestDebounced(url, options)) as Promise<
    ApiResponseType<ISubscription>
  >;

  return result;
}

export function deleteSubscription(subscriptionId: string, data: ISubscription) {
  const url = `${API_URL}/${subscriptionId}`;
  const options = {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  return makeRequest(url, options) as Promise<
    ApiResponseType<ISubscription>
  >;
}